import { render } from "./Create-category.vue?vue&type=template&id=d4f80e6a"
import script from "./Create-category.vue?vue&type=script&lang=js"
export * from "./Create-category.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__